<template>
    <el-container style="border: 0px solid #eee" class="home">
        <el-header style="padding:0;height:60px!important;" v-show="hasTopMenu">
            <h-top :systemName="systemName" :topTitle="topTitle" :username="username" :menuData="this.menuData" :pushLeftMenu="pushLeftMenu" :topIndexId="this.topIndexId"></h-top>
        </el-header>
        <el-container>
            <el-aside id="leftBox" :width="width">
                <h-leftMenu :leftMenuData="this.leftMenuData" :indexId="this.indexId" v-if="this.modalShow" :linkModule="this.linkModule" :curentTopMenuId="this.curentTopMenuId"></h-leftMenu>
            </el-aside>
            <el-main :style="'height:' + height + 'px;padding:0px'">
                <keep-alive>
                    <!--使用keep-alive会将页面缓存-->
                    <router-view v-if="this.$route.meta && this.$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!this.$route.meta || !this.$route.meta.keepAlive"></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import top from '../components/top.vue';
import leftMenu from '../components/leftMenu.vue';
import HashMap from 'hashmap';
function reciveAlarmInfo(message) {
    console.info(message.body);
}
export default {
    components: {
        'h-top': top,
        'h-leftMenu': leftMenu
    },
    data() {
        return {
            /* 是否显示顶部菜单 */
            hasTopMenu: true,
            height: window.innerHeight - 60,
            topTitle: '',
            username: '',
            menuData: [],
            leftMenuData: [],
            indexId: '',
            modalShow: true,
            topIndexId: '',
            curentTopMenuId: '',
            width: '227px',
            systemName: sessionStorage.getItem('systemName')
        };
    },
    methods: {
        linkModule: function (obj, curentTopMenuId) {
            let menuId = obj.menuId;
            this.$common.topMenuIdMap.set(curentTopMenuId, obj);
            this.indexId = menuId;
            this.$store.state.leftMenuIndex = menuId;
            this.$router.push('/' + menuId);
        },
        pushLeftMenu: function (menu) {
            let menuId = menu.menuId;
            let defaultId = '';
            if (menuId != this.curentTopMenuId) {
                let selectMenu = this.$common.topMenuIdMap.get(menuId);
                if (selectMenu) {
                    defaultId = selectMenu.menuId;
                }
                this.modalShow = false;
                if (menu.children && menu.children.length > 0) {
                    this.$nextTick(function () {
                        this.width = '227px';
                        this.modalShow = true;
                        this.$nextTick(function () {
                            this.leftMenuData = menu.children;
                            this.curentTopMenuId = menuId;
                            this.topIndexId = menu.menuId;
                            if (defaultId) {
                                this.$router.push('/' + defaultId);
                                this.indexId = defaultId;
                            } else {
                                this.getId(menu.children, this.curentTopMenuId);
                            }
                        });
                    });
                } else {
                    this.leftMenuData = [];
                    this.$store.state.leftMenuIndex = '';
                    this.width = '0px';
                    this.curentTopMenuId = menuId;
                    this.topIndexId = menuId;
                    if (menu.menuUrl.search('event') >= 0) {
                        let indexRex = menu.menuUrl.lastIndexOf(':');
                        let event = menu.menuUrl.substring(indexRex + 1, menu.menuUrl.length);
                        this.$EventBus.$emit(event, menu);
                        return;
                    }
                    if (menu.menuUrl) {
                        this.$router.push('/' + menuId);
                    } else {
                        this.$router.push('/blank');
                    }
                }
            } else if (!menu.children || menu.children.length <= 0) {
                this.$router.push('/' + menu.menuId);
            }
        },
        getId: function (data, curentTopMenuId) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].children.length > 0) {
                    this.getId(data[i].children, curentTopMenuId);
                    break;
                } else {
                    if (data[i].menuUrl.search('event') >= 0) {
                        let indexRex = data[i].menuUrl.lastIndexOf(':');
                        let event = data[i].menuUrl.substring(indexRex + 1, data[i].menuUrl.length);
                        this.$EventBus.$emit(event, data[i]);
                        return;
                    }
                    this.$common.topMenuIdMap.set(curentTopMenuId, data[i]);
                    this.$router.push('/' + data[i].menuId);
                    this.indexId = data[i].menuId;
                    break;
                }
            }
        },
        // 获取所有父菜单
        getParentChainMenuName: function (menuId) {
            let menuData = this.menuData;
            let menuMap = [];
            let menuNameArray = [];
            this.getAllMenu(menuData, menuMap);
            let obj = menuMap[menuId];
            while (obj) {
                let name = obj.menuName;
                if (name && name != null) {
                    menuNameArray.unshift(name);
                }
                obj = menuMap[obj.parentMenuId] !== obj ? menuMap[obj.parentMenuId] : null;
            }
            menuData = null;
            menuMap = null;
            return menuNameArray;
        },
        //获取所有菜单
        getAllMenu(menuData, menuMap) {
            if (menuData) {
                for (let i = 0; i < menuData.length; i++) {
                    if (menuData[i].menuId) {
                        menuMap[menuData[i].menuId] = menuData[i];
                    }
                    this.getAllMenu(menuData[i].children, menuMap);
                }
            }
        },
        initMQConfigInfo() {
            this.$dataBusUtil.init();
            this.$dataBusUtil.reciveMainChannel();
        },
        initReceiveAlarmInfo() {
            this.$dataBusUtil.receiveMsgByRoutingKey(this.$t('common.ALARM_CLIENT_CONSUME_ID'), this.$t('common.ALARM_CLIENT_ROUTING_KEY'), reciveAlarmInfo);
        }
    },
    watch: {
        curentTopMenuId(newVal) {
            sessionStorage.setItem('curentTopMenuId', newVal);
        },
        indexId(newVal) {
            sessionStorage.setItem('leftMenuIndexId', newVal);
        }
    },
    created() {
        /* 初始化系统标示信息 */
        this.$common.systemInfo.systemId = sessionStorage.getItem('systemId');
        /* 初始化菜单数据 */
        this.username = sessionStorage.getItem('username');
        this.menuData = JSON.parse(sessionStorage.getItem('menuData'));
        this.$common.menuData = this.menuData;
        this.$log.error('/fileController/ this.menuData ', this.menuData);
        let topMenuIdMap = new HashMap();
        for (let i = 0; i < this.menuData.length; i++) {
            topMenuIdMap.set(this.menuData[i].menuId, '');
        }
        this.$common.topMenuIdMap = topMenuIdMap;
        /* 初始化MQ配置信息 */
        this.initMQConfigInfo();
        /* 初始化接收报警信息 */
        // this.initReceiveAlarmInfo();
    },
    mounted() {
        //触发初始化事件
        this.$EventBus.$emit('initLoginEvent');
        if (window.config.SSO) {
            let hasTopMenu = this.$util.getUrlKey('hasTopMenu');
            if (!this.$util.isEmpty(hasTopMenu)) {
                if (hasTopMenu === 'false') {
                    this.hasTopMenu = false;
                }
            }
        }
        let request = {};
        request = this.$util.getRequest();
        this.topTitle = request['systemName'];
        window.getCurrentMenu = function () {
            let menuId = sessionStorage.getItem('leftMenuIndexId') != null ? sessionStorage.getItem('leftMenuIndexId') : sessionStorage.getItem('curentTopMenuId');
            return menuId != null ? this.getParentChainMenuName(menuId) : '';
        }.bind(this);
        this.$nextTick(function () {
            let curentTopMenuId = sessionStorage.getItem('curentTopMenuId');
            /* 登录还是刷新初始化不同的数据 */
            if (!curentTopMenuId) {
                if (this.menuData && this.menuData.length > 0) {
                    window.vue.$store.state.topMenuIndex = this.menuData[0].menuId;
                    this.pushLeftMenu(this.menuData[0]);
                } else {
                    this.width = '0px';
                }
            } else {
                let menuInfo = JSON.parse(sessionStorage.getItem('menuData'));
                menuInfo.forEach(menu => {
                    if (curentTopMenuId == menu.menuId) {
                        if (menu.children.length > 0) {
                            this.leftMenuData = menu.children;
                            this.modalShow = true;
                            this.indexId = sessionStorage.getItem('leftMenuIndexId');
                            this.$router.push('/' + this.indexId);
                        } else {
                            this.width = '0px';
                        }
                    }
                });
                this.topIndexId = curentTopMenuId;
                this.curentTopMenuId = curentTopMenuId;
            }
        });
        const that = this;
        window.addEventListener('resize', function () {
            that.height = window.innerHeight - 60;
        });
    },
    beforeDestroy() { }
};
</script>
